import React from 'react';
import box3 from '../../photos/box3.jpg'

function Box(props) {
    return (
        <div className='Box'>
            <img src={box3} alt="logo" width='100%' height='100%' />
        </div>
    );
}

export default Box;